// Copyright (c) 2016 Deere & Company

import './app-navigation.scss';
import React, { Component } from 'react';
import Factories from './factories';
import { NavLink } from 'react-router-dom';
import { getAccessPrivileges } from '../../repositories';


class AppNavigation extends Component {

    constructor () {

        super();

        this.toggle = this.toggle.bind( this );
        this.handleOutsideClick = this.handleOutsideClick.bind( this );

        this.state = {
            showMenu: false,
            showMassUpdateMenu: false,
            currentLocation: window.location.href,
            privileges: {},
            showNonDeereClaimMenu: false,
        };

        this.getPrivileges();

    }

    componentWillReceiveProps () {

        this.setState( { currentLocation: window.location.href } );

    }

    getPrivileges () {

        getAccessPrivileges().then( response => {

            this.setState( { privileges: response } );

        } ).catch( () => {

            this.setState( { privileges: {} } );

        } );

    }


    toggle ( menuName ) {

        let adminMenu = '';
        let massUpdateMenu = '';
        let nonDeereMenu = '';

        if (menuName === 'admin') {
            adminMenu = !this.state.showMenu;
        } else if (menuName === 'massUpdate') {
            massUpdateMenu = !this.state.showMassUpdateMenu;
        } else if (menuName === 'nondeereclaim') {
            nonDeereMenu = !this.state.showNonDeereClaimMenu;
        }

        if (menuName) {
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState({
            showMenu: adminMenu,
            showMassUpdateMenu: massUpdateMenu,
            showNonDeereClaimMenu: nonDeereMenu,
        });

    }

    handleOutsideClick ( e ) {

        if ( e.target.className === 'dropdown-span' ) return;
        this.toggle();

    }

    render () {

        const isMenuSelected = ( window.location.href.indexOf( '/admin' ) !== -1 );
        const isMassUpdateMenuSelected = ( window.location.href.indexOf( '/massupdate' ) !== -1 );
        const showFactories = ( this.state.currentLocation.indexOf( '/admin' ) === -1 );
        console.log("showFactories: ",showFactories);
        const isNonDeereClaimsSelected = ( window.location.href.indexOf( '/nondeereclaim' ) !== -1 );
        return (
            <nav className="app-navigation">
                <NavLink activeClassName="selected" className="home" exact to="/">
                    <span className="icon-home" />
                </NavLink>
                <NavLink activeClassName="selected" to={{ pathname: '/claims', state: 'findClaim' }}>
                    Find Claim
                </NavLink>
                {this.state.privileges.worklistEditable && (
                    <NavLink activeClassName="selected" to={{ pathname: '/worklist', state: 'worklist' }}>
                    Worklist
                    </NavLink>
                )}

                {this.state.privileges.massUpdateEditable && (
                    <span className={`${isMassUpdateMenuSelected ? 'dropdown selected' : 'dropdown'}`}>
                        <span className="dropdown-span" onClick={this.toggle.bind( this, 'massUpdate' )}>
                       Mass Updates
                            <span className={this.state.showMassUpdateMenu ? 'icon-dropUpArrow' : 'icon-dropDownArrow'} />
                        </span>
                        <div className={`dropdown-content ${this.state.showMassUpdateMenu ? 'show' : ''}`}>
                            <NavLink activeClassName="active" to={{ pathname: '/massupdate/batch-factory-data-upload', state: 'batchFactory' }}>
                                Batch Factory Data Upload
                            </NavLink>
                            <NavLink activeClassName="active" to={{ pathname: '/massupdate/batch-text-upload', state: 'batchText' }}>
                                Batch Text Upload
                            </NavLink>
                            <NavLink activeClassName="active" to={{ pathname: '/massupdate/analysis-comments-data-upload', state: 'analysisComments' }}>
                                Analysis Comments Data Upload
                            </NavLink>
                            <NavLink activeClassName="active" to={{ pathname: '/massupdate/batch-corrected-part_upload', state: 'batchFactory' }}>
                                Batch Upload Corrected Part Numbers
                            </NavLink>
                        </div>
                    </span>
                )}

                {this.state.privileges.adminScreenEditable && (
                    <span className={`${isMenuSelected ? 'dropdown selected' : 'dropdown'}`}>
                        <span className="dropdown-span" onClick={this.toggle.bind( this, 'admin' )}>
                        Admin
                            <span className={this.state.showMenu ? 'icon-dropUpArrow' : 'icon-dropDownArrow'} />
                        </span>
                        <div className={`dropdown-content ${this.state.showMenu ? 'show' : ''}`}>
                            <NavLink activeClassName="active" to={{ pathname: '/admin/warranty-code-maintainence', state: 'warranty' }}>
                            Warranty Product Structure Maintenance
                            </NavLink>
                            <NavLink activeClassName="active" to={{ pathname: '/admin/function-code-maintainence', state: 'functionCode' }}>
                            Function Code Maintenance
                            </NavLink>
                            <NavLink activeClassName="active" to={{ pathname: '/admin/component-function-code-maintainence', state: 'componentCode' }}>
                            Component Function Code Maintenance
                            </NavLink>
                            <NavLink activeClassName="active" to={{ pathname: '/admin/part-group-maintainence', state: 'partGroup' }}>
                            Part Group Maintenance
                            </NavLink>
                        </div>
                    </span>
                )}
                 <span className={`${isNonDeereClaimsSelected ? 'dropdown selected' : 'dropdown'}`}>
                        <span className="dropdown-span" onClick={this.toggle.bind( this, 'nondeereclaim' )}>
                        Non Deere Claims
                            <span className={this.state.showNonDeereClaimMenu ? 'icon-dropUpArrow' : 'icon-dropDownArrow'} />
                        </span>
                        <div className={`dropdown-content ${this.state.showNonDeereClaimMenu ? 'show' : ''}`}>
                        <NavLink activeClassName="active" to={{ pathname: '/nondeere/claim-search', state: 'nondeereclaimsearch' }}>
                    Find Claims
                </NavLink>
                  <NavLink activeClassName="active" to={{ pathname: '/nondeere/claim-upload', state: 'nondeereclaim' }}>
                    Upload Claims
                </NavLink>
                </div>
                </span>
                
                {showFactories ? null : <Factories className={showFactories ? 'hide' : ''} />
    }

            </nav>
        );

    }

}
AppNavigation.displayName = 'AppNavigation';
export default AppNavigation;
